import { render, staticRenderFns } from "./homeIndex.vue?vue&type=template&id=0fbb73e2&"
import script from "./homeIndex.vue?vue&type=script&lang=js&"
export * from "./homeIndex.vue?vue&type=script&lang=js&"
import style0 from "./homeIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports